// app/src/components/Sheet.jsx — the mobile bottom sheet (handoff: pickers/menus open a bottom
// sheet over a dimmed scrim with a drag handle). Scrim click closes; content stops propagation.
// D-AUTH §6 adds Escape via the shared dismiss seam (the scrim already handles outside-tap —
// pointerdowns outside the panel land on the scrim, so the controller and the scrim agree).

import React, { useRef } from 'react';
import { useDismiss } from '@common/dismiss.js';

export function Sheet({ open, onClose, title, children }) {
  const panelRef = useRef(null);
  useDismiss(panelRef, onClose, { enabled: open });
  if (!open) return null;
  return (
    <div className="sheet-scrim" onClick={onClose}>
      <div ref={panelRef} className="sheet-panel" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="sheet-handle" />
        {title && <div className="sheet-title">{title}</div>}
        {children}
      </div>
    </div>
  );
}
